import React, { useCallback, useMemo, useState } from "react";
import { Spin, Table } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import "./tablelist.css";

const TableList = ({
  data,
  columns,
  hasMoreData,
  tableLoading,
  fetchMoreData,
  className,
}) => {
  const [loadingMore, setLoadingMore] = useState(false);

  const dataSource = useMemo(
    () =>
      (data ?? []).map((item, index) => ({
        ...item,
        key: index,
      })),
    [data],
  );

  const handleFetchMore = useCallback(async () => {
    setLoadingMore(true);
    try {
      await Promise.resolve(fetchMoreData?.());
    } finally {
      setLoadingMore(false);
    }
  }, [fetchMoreData]);

  const spinning = tableLoading || loadingMore;

  return (
    <div className="tableContainerStyling">
      <Spin
        spinning={spinning}
        size="large"
        wrapperClassName="tableListSpinFill"
      >
        <div className="scroll-container" id="scrollableDiv">
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            dataLength={dataSource.length}
            next={handleFetchMore}
            hasMore={hasMoreData}
            loader={null}
          >
            <Table
              className={
                className ? `tableStyling ${className}` : "tableStyling"
              }
              columns={columns}
              dataSource={dataSource}
              pagination={false}
            />
          </InfiniteScroll>
        </div>
      </Spin>
    </div>
  );
};

export default React.memo(TableList);
